<template>
    <section class="nutrition-info">
        <h2 class="title" v-test:title>{{ $snippet('nutrition', 'nutrition') }}</h2>
        <markdown-content v-if="text" :content="text" />
        <nutrition-facts :facts="facts" />
    </section>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';
    import NutritionFacts from '../../atoms/NutritionFacts/NutritionFacts';

    export default {
        name: 'nutrition-info',

        components: { MarkdownContent, NutritionFacts },

        props: {
            text: {
                type: String,
                default: '',
            },

            facts: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .title {
        font-size: rem(24px);
        line-height: rem(28px);
        font-weight: 700;
        margin-bottom: 8px;
        @include media-breakpoint-up(md) {
            margin-bottom: 16px;
        }
    }
</style>
